import { fetchWorkdays, filterAction, resetFilterAction } from '../actions/index';
import HoursOfServiceModal from './hours-of-service-modal';
import ClaimsEmployeesWorkday from './claims-employees-workday';
import ActivityModal from './activity-modal';
import CommentsModal from './comments-modal';
import AdminCommonSection from '../components/adminLayout';
import {React, Component, bindActionCreators, connect, Filters, Pagination, constants, KeolisSpinner, moment} from './common/commonExport';
import PDFPrinting from './PDFPrinting';

class AcceptedClaims extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            totalRecords: '',
            numberOfPages: '',
            pageNum: 1, 
            filterState:{}
        }
    }

    getData(pageNum, filterObj){  //create get data function
        if(filterObj){
            filterObj = filterObj;
        } else {
            filterObj = this.state.filterState;
        }
        let self = this,
            authDetails = this.props.authDetails,
            role = authDetails.role;
            pageNum = filterObj.byPagination ? (pageNum) : (filterObj.byFilter ? 1 : pageNum);
        if(role == "Admin"){
            this.last_to_prev = false;
            this.key = 'noKey';
            this.event = 'first';
            let fetchObj = {
                url:constants.actionUrls.ADMIN_URL,
                role: role,
                certifyStatus: constants.ACCEPTED_CLAIM,
                pageNum:pageNum,
                filterObj:filterObj
            }
            this.props.fetchWorkdays(fetchObj, function(response){
                self.setState({
                    numberOfPages: response.totalPages,
                    pageNum: pageNum
                })
            });
            localStorage.setItem('route', constants.ACCEPTED_CLAIM);
        }
    };

    resetFilter(filterObj){
        let self = this;   
        filterObj["outlaw"] = false;
        this.props.resetFilter(filterObj, function(response){
            self.setState({
                filterState:response
            });
        });
    }
    componentWillMount() {
        let filterObj = this.props.filterState.defaultState ? this.props.filterState.defaultState:
                        this.props.filterState;
        this.resetFilter(filterObj);
    }
    componentDidMount(){
        let pageNum = this.state.pageNum;
        this.getData(pageNum);
    }

    renderModal() {
        if (this.props.showModal && this.props.modalName == "Certified_Modal") {
            return (
                <HoursOfServiceModal workday={this.props.workday} />
            )
        } else if (this.props.showModal && this.props.modalName == "Certify_Modal") {
            return (
                <ActivityModal  />
            )
        } else if (this.props.modalName == "Comments_Modal") {
            return (
                <CommentsModal />
            )
        }
    }
    renderPagination() {
        let { pageNum, numberOfPages} = this.state,
            workdays = this.props.workdays, showPagination=false;
        if(workdays && workdays.length > 0 && numberOfPages > 1){
            showPagination = true;
        }
        return (<Pagination ShowPagination={showPagination} currentPage={pageNum}
            pageSize={numberOfPages} GetData={(pageNum, filterObj) => this.getData(pageNum, filterObj)} />)
    }
    renderWorkdays() {
        var ext_first_key, wdy_date, then, role = this.props.authDetails.role;
        if (this.props.isLoading) {
            return(
                <tr>
                    <td>
                        <KeolisSpinner />
                    </td>
                </tr>
            )
        }
        else if (this.props.workdays && this.props.workdays.length >= 0) {
            
            if (this.props.paginationState) {
                var paginationState = this.props.paginationState.paginationState;
            }
            var workdays = this.props.workdays,
                timeElapsed,
                now = moment(new Date(), "MM/DD/YYYY HH:mm"),
                now = now.format('MM/DD/YY HH:mm');
            for (var i = 0; i < workdays.length; i++) {
                var workdayTime = workdays[i].wdy_time_end.split(":");
                if (workdayTime[0] > 23) {
                    wdy_date = moment(workdays[i].wdy_date, "MM/DD/YY").add(1, 'days').format("MM/DD/YY")
                    then = wdy_date + ' ' + Math.abs(24 - workdayTime[0]) + ':' + workdayTime[1]
                } else {
                    wdy_date = workdays[i].wdy_date
                    then = wdy_date + ' ' + workdays[i].wdy_time_end
                }
                var timeDiff = moment(then, "MM/DD/YYYY HH:mm").diff(moment(now, "MM/DD/YYYY HH:mm")),
                    d = moment.duration(timeDiff);
                workdays[i]['timeElapsed'] =
                    (d.days() == 0 ? '' : (d.days() + 'd'))
                    + (d.days() ? (d.hours() == 0 ? '0h' : d.hours() < 0 ? (d.hours() * -1 + 'h') : d.hours() + 'h') : d.hours() == 0 ? '' : d.hours() + 'h')
                    + ((d.hours() || d.days()) ? d.minutes() >= 0 ? d.minutes() : (d.minutes() * -1) : d.minutes() + 'm')
            }
            return (
                workdays.length == 0 ?
                <tr>
                    <td colSpan="100%">
                        No records available...
                    </td>
                </tr>
                    :
                    workdays.map(function (workday, index) {
                        return (
                            <ClaimsEmployeesWorkday workday={workday} key={index} role={role} parent={'accept'} />
                        );
                    })
            )
        } else {
            return (
                <tr>
                    <td colSpan="100%">
                        <KeolisSpinner  />
                    </td>
                </tr>
            )
        }
    }
    getFilteredData(e, data){
        
        let pageNum = this.state.pageNum,filterObj = data;
        if(e){
            e.preventDefault();
        } 
        this.props.submitFilter(data);
        this.getData(pageNum, filterObj);
    }

    render() {
        var workdays = this.props;
        var route = localStorage.getItem('route') ? localStorage.getItem('route') : '',
            compTitle = constants.getComponentTitle(route);
        return (
            <AdminCommonSection compTitle={compTitle} admin={true}
                tblBody={
                    <div>
                        <Filters getData = {(e, data) => this.getFilteredData(e, data)}/>
                        <PDFPrinting Page="Projects" compTitle = {compTitle} pageNo = {this.state.pageNum}/>
                    <div id="tblMainActivities">
                        <table className="table table-striped table-bordered_header table-condensed">
                        <thead className="thead-default">
                        <tr className="text-center">
                            <th>Division</th>
                            <th className="text-center">Employee ID</th>
                            <th className="text-center">Job</th>
                            <th className="text-center">First Name</th>
                            <th className="text-center">Last Name</th>
                            <th className="text-center">Service Date</th>
                            <th className="text-center">
                                <span className="subHead">System</span>
                                <table width="100%">
                                    <thead>
                                        <tr>
                                            <td className="text-center">HOS</td>
                                            <td className="text-center">TOS</td>
                                        </tr>
                                    </thead>
                                </table>
                            </th>
                            <th className="text-center">
                                <span className="text-center subHead">Adjusted</span>
                                <table width="100%">
                                    <thead>
                                        <tr>
                                            <td className="text-center">HOS</td>
                                            <td className="text-center">TOS</td>
                                        </tr>
                                    </thead>
                                </table>
                        </th>
                        <th className="text-center">
                            <span className="text-center subHead">Differential</span>
                            <table width="100%">
                                <thead>
                                    <tr>
                                        <td className="text-center">HOS</td>
                                        <td className="text-center">TOS</td>
                                    </tr>
                                </thead>   
                            </table>
                        </th>
                            <th className="text-center">Date</th>                            
                            {/* Newly Added Column Name Hastus Status */}
                            <th className="text-center">Hastus Status</th>

                        </tr>

                    </thead>
                            <tbody>
                            {
                                
                                this.renderWorkdays()
                            }
                        </tbody>
                        </table>
                        {
                            this.renderModal()
                        }
                        </div>
                        { 
                            this.renderPagination()
                        }
                        </div>
                }
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        workdays: state.workdays.workdays,
        hasErrored: state.workdays.itemsHasErrored,
        isLoading: state.workdays.isLoading,
        showModal: state.modals.showModal,
        modalName: state.modals.modalName,
        workday: state.workday.workday,
        authDetails:state.authState,
        filterState:state.filter
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {fetchWorkdays: fetchWorkdays,
            submitFilter: filterAction,
            resetFilter:resetFilterAction}, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(AcceptedClaims);
